import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { i18n } from '../i18n'
import { createPinia } from 'pinia'
import ServicesIndex from '../views/ServicesIndex.vue'
import { app } from '../app'

const pinia = createPinia()

createApp({
  components: {
    ServicesIndex
  },
  extends: app
})
  .use(vuetify)
  .use(i18n)
  .use(pinia)
  .mount('#app')
